export function manageAvaUsersPath(id) {
  return `https://tooljet.revops.agendor.com.br/applications/ava-users?accountId=${id}`;
}
